export type FeatureAvailability = "disabled" | "local" | "enabled";

const LOOPBACK_HOSTS = new Set(["127.0.0.1", "::1", "[::1]"]);

export function isLocalHostname(hostname: string) {
  const normalised = hostname.trim().toLowerCase().replace(/\.$/, "");
  return (
    normalised === "localhost" ||
    normalised.endsWith(".localhost") ||
    LOOPBACK_HOSTS.has(normalised)
  );
}

export function featureIsAvailable(
  availability: string | undefined,
  hostname: string,
) {
  const normalised = availability?.trim().toLowerCase();
  if (normalised === "enabled") return true;
  if (normalised === "local") return isLocalHostname(hostname);
  return false;
}
